<template>
  <div>
    <ValidationObserver ref="validform">
      <form @submit.prevent="submit()">
        <main class="main reception card-sales-connect">
          <div class="section top">
            <!-- <div class="top__headline">
              <h2>카드매출 불러오기</h2>
            </div> -->
            <div class="top__sub-headline">
              <h4>
                사장님의 비상금 한도산출을 위해<br/>
                카드 매출을 조회할 수 있는 <b>여신금융협회</b><br/>
                <b>계정 연동이 꼭 필요</b>합니다!
              </h4>
            </div>
          </div>
          <div class="section signin-cfa">
            <a
              v-ripple
              href="https://www.cardsales.or.kr/page/member/join/joinForm"
              class="signin-cfa--rectangle"
              target="_blank"
            >
              1분 여신금융협회 계정 만들기
              <img src="../../assets/images/ic-left-blue.svg" alt="greater-then-sign" />
            </a>
          </div>
          <div class="section form-group mt-30px">
            <form>
              <div class="field-group cfa-id">
                <FormInput
                  type="text"
                  name="id"
                  v-model="credential.user_id"
                  rules="required"
                  placeholder="여신금융협회 아이디를 입력해주세요."
                />
              </div>
              <div class="field-group cfa-pw">
                <FormInput
                  type="password"
                  name="pwd"
                  v-model="credential.user_password"
                  rules="required"
                  placeholder="여신금융협회 비밀번호를 입력해주세요."
                />
              </div>
            </form>
          </div>
          <!-- class="section bottom" -->
        </main>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import FormInput from '@/components/form/FormInput'
import PrefetchService from '@/service/auth/PrefetchService'

export default {
  components: {
    FormInput
  },
  data() {
    return {
      credential: {
        provider: null,
        user_id: null,
        user_password: null
      }
    }
  },
  props: {
    provider: String,
    user_id: String,
    user_password: String,
    isInProgress: Boolean
  },
  created() {
    // Prefetch
    let query = PrefetchService.filterQuery(this.$route.query)
    if (!query) {
      return
    } else {
      this.token = query.token
    }
    if (this.provider) { this.credential.provider = this.provider }
    if (this.user_id) { this.credential.user_id = this.user_id }
    if (this.user_password) { this.credential.user_password = this.user_password }
  },
  watch: {
    user_id: function (newUserId) {
      this.credential.user_id = newUserId
      if (window.prefetched === true) { return }
      this.submit()
    },

    user_password: function (newUserPassword) {
      this.credential.user_password = newUserPassword
      if (window.prefetched === true) { return }
      this.submit()
    }
  },
  methods: {
    submit() {
      if (!this.token && this.isInProgress === true) { // 이미 로그인 중
        return
      }
      if (!this.token && !(this.$refs && this.$refs.validform && this.$refs.validform.flags && this.$refs.validform.flags.valid === true)) { // Form 체크
        return
      }
      this.credential.provider = this.provider
      window.prefetched = true
      if (this.credential.user_id && this.credential.user_password) {
        this.$emit('submit', this.credential)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .top__sub-headline {
    .sub {
      font-size: 12px;
    }
  }
  .main.reception.card-sales-connect {
    min-height: unset;
    margin-bottom: 60px;

    .top {
      margin-top: 27px;
      padding-top: 0;
    }
  }
</style>
